import { render, staticRenderFns } from "./OperationDocs.vue?vue&type=template&id=6d2cb8b8&scoped=true"
import script from "./OperationDocs.vue?vue&type=script&lang=ts"
export * from "./OperationDocs.vue?vue&type=script&lang=ts"
import style0 from "./OperationDocs.vue?vue&type=style&index=0&id=6d2cb8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2cb8b8",
  null
  
)

export default component.exports